import useSWR from 'swr';
import { useMemo } from 'react';

import { httpGet, httpPost, httpPostRead } from 'src/utils/cms-axios';

export function getPkg(data) {

  const { site_id, code } = data

  return httpGet("/page/pkg", {
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getPagePkgList(data) {

  const { site_id } = data

  return httpGet("/page/pkg_list", {}, {
    "cms-site-id": site_id,
  });
}

export function getPage(data) {

  const { site_id, page_id, page_pkg_code } = data

  return httpGet("/page", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getProxy(data) {

  const { site_id, page_id, page_pkg_code } = data

  return httpGet("/page/proxy", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getCustomize(data) {

  const { site_id, page_id, page_pkg_code } = data

  return httpGet("/page/customize", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getPost(data) {

  const { site_id, page_id, page_pkg_code } = data

  return httpGet("/page/post", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getPageList(data) {

  const { site_id, page_pkg_code, limit, offset } = data

  // 副作用のない一覧取得。間欠 500 に備えて再試行させる（httpPostRead）
  return httpPostRead("/page/list", {
    "page_pkg_code": page_pkg_code,
    "limit": limit,
    "offset": offset,
  }, {
    "cms-site-id": site_id,
  });
}

export function createPkg(data) {

  const { site_id, code, name, expand_value } = data

  return httpPost("/page/pkg/create", {
    "name": name,
    "code": code,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function updatePkg(data) {

  const { site_id, code, name, expand_value } = data

  return httpPost("/page/pkg/update", {
    "code": code,
    "name": name,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function deletePkg(data) {

  const { site_id, code } = data

  return httpPost("/page/pkg/delete", {
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function createProxy(data) {

  const { site_id, page_pkg_code, page_name, page_type, url_prefix, proxy_url, expand_value } = data

  return httpPost("/page/proxy/create", {
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "proxy_url": proxy_url,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function updateProxy(data) {

  const { site_id, page_id, page_pkg_code, page_name, page_type, url_prefix, proxy_url, expand_value } = data

  return httpPost("/page/proxy/update", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "proxy_url": proxy_url,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function createCustomize(data) {

  const { site_id, page_pkg_code, page_name, page_type, url_prefix, tpl_code, expand_value } = data

  return httpPost("/page/customize/create", {
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "tpl_code": tpl_code,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function updateCustomize(data) {

  const { site_id, page_id, page_pkg_code, page_name, page_type, url_prefix, tpl_code, expand_value } = data

  return httpPost("/page/customize/update", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "tpl_code": tpl_code,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function createPage(data) {

  const { site_id, page_pkg_code, page_name, page_type, url_prefix, tpl_code, expand_value } = data

  return httpPost("/page/create", {
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "tpl_code": tpl_code,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function updatePage(data) {

  const { site_id, page_id, page_pkg_code, page_name, page_type, url_prefix, tpl_code, expand_value } = data

  return httpPost("/page/update", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "url_prefix": url_prefix,
    "tpl_code": tpl_code,
    "expand_value": expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function deletePage(data) {

  const { site_id, page_id, page_pkg_code } = data

  return httpPost("/page/delete", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function createPost(data) {

  const { site_id, page_pkg_code, page_name, page_type, post_type_id,
    list_url_prefix, list_url_path, list_tpl_code, list_expand_value,
    detail_url_prefix, detail_url_path, detail_tpl_code, detail_expand_value } = data

  return httpPost("/page/post/create", {
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "post_type_id": post_type_id,
    "list_url_prefix": list_url_prefix,
    "list_url_path": list_url_path,
    "list_tpl_code": list_tpl_code,
    "list_expand_value": list_expand_value,
    "detail_url_prefix": detail_url_prefix,
    "detail_url_path": detail_url_path,
    "detail_tpl_code": detail_tpl_code,
    "detail_expand_value": detail_expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function updatePost(data) {

  const { site_id, page_id, page_pkg_code, page_name, page_type,
    post_type_id, list_url_prefix, list_url_path, list_tpl_code,
    list_expand_value, detail_url_prefix, detail_url_path,
    detail_tpl_code, detail_expand_value } = data

  return httpPost("/page/post/update", {
    "page_id": page_id,
    "page_pkg_code": page_pkg_code,
    "page_name": page_name,
    "page_type": page_type,
    "post_type_id": post_type_id,
    "list_url_prefix": list_url_prefix,
    "list_url_path": list_url_path,
    "list_tpl_code": list_tpl_code,
    "list_expand_value": list_expand_value,
    "detail_url_prefix": detail_url_prefix,
    "detail_url_path": detail_url_path,
    "detail_tpl_code": detail_tpl_code,
    "detail_expand_value": detail_expand_value,
  }, {
    "cms-site-id": site_id,
  });
}

export function pageOptionMaster(data) {

  const { site_id, page_pkg_code, page_text, page_array } = data

  return httpPost("/page/page/option-master", {
    "page_pkg_code": page_pkg_code,
    "page_text": page_text,
    "page_array": page_array,
  }, {
    "cms-site-id": site_id,
  });
}

export function useGetPage(site_id, page_pkg_code, page_id) {
  const { data, isLoading, error, isValidating, mutate } = useSWR({ site_id, page_pkg_code, page_id }, getPage)

  const memoizedValue = useMemo(
    () => ({
      page: data || null,
      pageLoading: isLoading,
      pageError: error,
      pageValidating: isValidating,
      pageRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue
}

export function useGetPostPage(site_id, page_pkg_code, page_id) {
  const { data, isLoading, error, isValidating, mutate } = useSWR({ site_id, page_pkg_code, page_id }, getPost)

  const memoizedValue = useMemo(
    () => ({
      page: data || null,
      pageLoading: isLoading,
      pageError: error,
      pageValidating: isValidating,
      pageRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue
}

export function useGetPagePkgList(site_id) {

  const shouldFetch = Boolean(site_id);

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    shouldFetch ? { site_id, type: 'page_pkg_list' } : null,
    () => getPagePkgList({ site_id })
  )

  const memoizedValue = useMemo(
    () => ({
      pkgList: data || null,
      pkgLoading: isLoading || !shouldFetch,
      pkgError: error,
      pkgValidating: isValidating,
      pkgRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate, shouldFetch]
  );

  return memoizedValue
}

export function useGetPages(site_id, datas) {

  const { page_pkg_code, limit, offset } = datas

  const { data, isLoading, error, isValidating, mutate } = useSWR({ site_id, page_pkg_code, limit, offset }, getPageList)

  const memoizedValue = useMemo(
    () => ({
      pages: data?.page_list || [],
      pagesCount: data?.count || 0,
      pagesLoading: isLoading,
      pagesError: error,
      pagesValidating: isValidating,
      pagesEmpty: !isLoading && !data?.count,
      pagesRefresh: mutate,
    }),
    [mutate, data, error, isLoading, isValidating]
  );

  return memoizedValue
}

export function useGetPagePkg(site_id, code) {

  const { data, isLoading, error, isValidating, mutate } = useSWR(site_id && code ? { site_id, code } : null, getPkg)

  const memoizedValue = useMemo(
    () => ({
      pkg: data || null,
      pkgLoading: isLoading,
      pkgError: error,
      pkgValidating: isValidating,
      pkgRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue
}
